<template>
  <div :class="`flight-pad-price-button flight-pad-price-button__${direction}`">
    <div class="flight-pad-price-button__box">
      <div class="flight-pad-price-button__amount">
        <div class="d-flex flex-column">
          <span class="h3 m-0 semibold text-primary text-nowrap">
            {{ currency(flight_offer.price.currency) }}
            {{
              number(get_markup(flight_offer).mu_price_medium_per_pax).toFixed(
                2
              )
            }}
          </span>
          <span class="flight-pad-price-button__text text-muted">
            per persona
          </span>
        </div>
      </div>
    </div>
    <div class="d-flex w-100 px-4 flex-column justify-content-center">
      <p
        v-if="get_availability(get_markup(flight_offer).mu_price).show_credit_alert"
        :class="`${
          !get_availability(get_markup(flight_offer).mu_price).show_credit_alert
            ? 'hidden-credit-warning'
            : 'visible-credit-warning'
        } credit-warning text-center text-danger`"
        v-b-popover.hover.bottom="
          'Il tuo credito welfare non è sufficiente ad acquistare questa soluzione'
        "
      >
        <vb-icon :name="'info'" :size="14" :color="sass('danger')"> </vb-icon>
        Credito non sufficiente
      </p>

      <custom-link
        :before_navigation="() => select_flight_offer(flight_offer)"
        :route_name="'detail'"
        css_class="d-flex justify-content-center"
        :as_default="get_config('guiSettings.openDetailNewTab', false)"
      >
        >
        <template #content>
          <vb-button
            :vb_options="{
              classes: 'flex-grow-1',
              text: 'Scegli',
              variant: 'info',
              size: 'md',
            }"
          />
        </template>
      </custom-link>
    </div>
  </div>
</template>

<script>
import {
  get_markup,
  select_flight_offer,
} from "@liveflight/utilities/flight-offer";
import { currency } from "@liveflight/utilities/mixins";
import { get_availability } from "@/utilities/commons";
import { number } from "mathjs";

export default {
  name: "flight-pad-price-button",
  props: {
    flight_offer: Object,
    direction: {
      type: String,
      default: () => "",
    },
  },
  methods: {
    number,
    currency,
    select_flight_offer,
    get_availability,
    get_markup,
  },
};
</script>

<style lang="scss" scoped>
.flight-pad-price-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  justify-items: center;
  height: 100%;

  .hidden-credit-warning {
    max-height: 0px;
    margin: 0;
    padding: 0;
    line-height: 0;
    opacity: 0;
  }
  .visible-credit-warning {
    margin-bottom: 5px;
    display: flex;
    justify-content: center;
    justify-items: center;
    align-items: center;
    gap: 5px;
    font-size: 14px;
  }
  &__box {
    display: flex;
    font-size: $font-size-lg;
    width: max-content;
  }
  &__currency {
    margin-right: 6px;
  }
  &__amount {
    width: 100%;
    text-align: center;
    margin-bottom: 5px;
  }
  &__text {
    font-size: $font-size-sm;
    text-align: center;
  }

  &__horizontal {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 30px;

    &__text {
      text-align: start;
    }
  }

  @include media-breakpoint-down(md) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: $grid-gutter-width / 3;

    &__text {
      text-align: start;
    }
  }
}
</style>
